import { Button } from "@mui/material";
import React, { useState, useRef } from "react";
import Webcam from "react-webcam";

const CardPhotography = ({ info, onCapture }) => {
  const [showCamera, setShowCamera] = useState(true);
  const webcamRef = useRef(null);
  const videoConstraints = {
    facingMode: "environment",
  };

  const takePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setShowCamera(false);
    onCapture(imageSrc);
  };

  const renderCamera = () => {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        }}
      >
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          style={{ objectFit: "contain" }}
        />
        {info.id === "1" && (
          <>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "85.6mm",
                height: "53.98mm",
                border: "4px solid darkblue",
                borderRadius: "16px",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: "30%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "80%",
                  height: "2px",
                  background: "darkblue",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "70%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "80%",
                  height: "2px",
                  background: "darkblue",
                }}
              />
            </div>
          </>
        )}
        {info.id === "2" && (
          <>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "85.6mm",
                height: "53.98mm",
                border: "4px solid darkblue",
                borderRadius: "16px",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "80%",
                  height: "2px",
                  background: "darkblue",
                }}
              />
            </div>
          </>
        )}
        {info.id === "3" && (
          <>
            <span
              style={{
                position: "absolute",
                top: "43%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "65%",
                height: "2px",
                background: "darkblue",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "65%",
                height: "2px",
                background: "darkblue",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "58%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                height: "10px",
                background: "darkblue",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "10%",
                transform: "translate(-50%, -50%) rotate(-70deg)",
                width: "35%",
                height: "2px",
                background: "darkblue",
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "90%",
                transform: "translate(-50%, -50%) rotate(70deg)",
                width: "35%",
                height: "2px",
                background: "darkblue",
              }}
            />
          </>
        )}
        <Button
          variant="contained"
          color="primary"
          style={{
            position: "absolute",
            bottom: "40px",
            left: "50%",
            transform: "translate(-50%, 0)",
          }}
          onClick={takePhoto}
        >
          {info.title}を撮る
        </Button>
      </div>
    );
  };

  return <>{showCamera && renderCamera()}</>;
};

export default CardPhotography;
